import { render, staticRenderFns } from "./ProjectDetailsPage.vue?vue&type=template&id=4bbfb8e3&scoped=true&"
import script from "./ProjectDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailsPage.vue?vue&type=style&index=0&id=4bbfb8e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbfb8e3",
  null
  
)

export default component.exports